import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************
class serverOrderProcessingApi {
    static getOrder(orderId: string) {
        return sendRequest(
            requestOptions(config.URL + `orders/${orderId}`,
                requestTypes.GET,
            ),
        );
    }

    static placeAnOrder(placeAnOrder: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `orders`,
                requestTypes.PUT,
                JSON.stringify(placeAnOrder),
                apiConstants.successMessage.order.PLACE_AN_ORDER,
            ),
        );
    }

    static receiveOrder(receiveOrderModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `order-fulfilment`,
                requestTypes.POST,
                JSON.stringify(receiveOrderModel),
                apiConstants.successMessage.order.RECEIVED_ORDER,
            ),
        );
    }

    static fulfillOrder(sanitizedModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `order-fulfilment`,
                requestTypes.PUT,
                JSON.stringify(sanitizedModel),
                apiConstants.successMessage.order.FULFILL_ORDER,
            ),
        );
    }

    static revertOrderFromComplete(orderId: string) {
        return sendRequest(
            requestOptions(config.URL + `order-fulfilment/${orderId}/revert-from-complete`,
                requestTypes.PUT,
                null,
                apiConstants.successMessage.order.REVERT_FROM_COMPLETE,
            ),
        );
    }

}

export const orderProcessingApi = config.environment.MODE === config.modes.SERVER ? serverOrderProcessingApi : serverOrderProcessingApi;
